import { Component, inject, OnInit, ViewChild } from '@angular/core';
import {
  DxButtonComponent,
  DxDataGridComponent,
  DxDateBoxComponent,
  DxLoadPanelComponent,
  DxNumberBoxComponent,
  DxPopupComponent,
  DxTemplateDirective,
  DxTextBoxComponent,
  DxValidationGroupComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import {
  DxiButtonComponent,
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoLookupComponent,
  DxoSelectionComponent,
} from 'devextreme-angular/ui/nested';
import { alert, confirm } from 'devextreme/ui/dialog';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { RUOLO_OPERATORE_BASE } from 'src/app/consts/const';
import { Articoli } from 'src/app/models/articoli';
import { ArticoliMatricola } from 'src/app/models/articoli-matricola';
import { DettaglioMovimento } from 'src/app/models/dettaglio-movimento';
import { Dipendente } from 'src/app/models/dipendente';
import { KitArticoli } from 'src/app/models/kit-articolo';
import {
  MovimentoArticoloModel,
  TipoGestioneGiornaliera,
} from 'src/app/models/movimento-articolo';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { PopupSceltaArticoloComponent } from 'src/app/shared/components/popups/popup-scelta-articolo/popup-scelta-articolo.component';
import { PopupSceltaDipendenteComponent } from 'src/app/shared/components/popups/popup-scelta-dipendente/popup-scelta-dipendente.component';
import { PopupSceltaMatricolaComponent } from 'src/app/shared/components/popups/popup-scelta-matricola/popup-scelta-matricola.component';
import { ArticoliMatricolaService } from 'src/app/shared/services/articoli-matricola.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { KitArticoliService } from 'src/app/shared/services/kit-articoli.service';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { ParametriService } from 'src/app/shared/services/parametri.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

@Component({
  selector: 'app-consegna-guidata',
  templateUrl: './consegna-guidata.component.html',
  styleUrls: ['./consegna-guidata.component.scss'],
  imports: [
    DxButtonComponent,
    DxValidationGroupComponent,
    DxiValidationRuleComponent,
    DxValidatorComponent,
    DxDateBoxComponent,
    DxTextBoxComponent,
    DxDataGridComponent,
    DxiButtonComponent,
    DxoEditingComponent,
    DxiColumnComponent,
    DxoLookupComponent,
    DxLoadPanelComponent,
    DxNumberBoxComponent,
    DxPopupComponent,
    PopupSceltaDipendenteComponent,
    PopupSceltaArticoloComponent,
    PopupSceltaMatricolaComponent,
    DxTemplateDirective,
    DxoSelectionComponent,
  ],
})
export class ConsegnaGuidataComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  constructor() {
    super();
    this.getFilteredArticoli = this.getFilteredArticoli.bind(this);
    this.onTipoArticoloChanged = this.onTipoArticoloChanged.bind(this);
    this.eliminaMatricolaArticolo = this.eliminaMatricolaArticolo.bind(this);
    this.eliminaArticolo = this.eliminaArticolo.bind(this);
    this.onCodiceDipendenteChanged = this.onCodiceDipendenteChanged.bind(this);
    this.onMatricolaArticolo = this.onMatricolaArticolo.bind(this);
    this.onIdMatricolaEventEmitter = this.onIdMatricolaEventEmitter.bind(this);
  }

  @ViewChild('gridDettaglioMov', { static: false })
  gridDettaglioMov!: DxDataGridComponent;
  @ViewChild('barcodeArticolo', { static: false })
  barcodeArticoloTxtBox!: DxTextBoxComponent;
  @ViewChild('barcodeDipendente', { static: false })
  barcodeDipendenteTxtBox!: DxTextBoxComponent;
  @ViewChild('barcodeMatricola', { static: false })
  barcodeMatricola!: DxTextBoxComponent;
  private storageService = inject(StorageService);
  private navigatorService = inject(NavigatorService);
  private dipendentiService = inject(DipendentiService);
  private matricoleService = inject(ArticoliMatricolaService);
  private tipiArticoliService = inject(TipiArticoliService);
  private articoliService = inject(ArticoliService);
  private kitArticoliService = inject(KitArticoliService);
  private movimentoService = inject(MovimentoArticoliService);
  private parametriService = inject(ParametriService);

  private lastInsertTime = Date.now();

  isBase: boolean = true;
  listDipendenti: Dipendente[];
  listArticoli: Articoli[];
  listMatricole: ArticoliMatricola[] = [];
  listTipiArticoli: TipiArticoli[];
  listKitArticoli: KitArticoli[];
  listArticoliFiltro: Articoli[];

  dataConsegna: Date;
  idDipendente: number;
  codiceDipendente: string = '';

  nuovoMovimento: MovimentoArticoloModel;
  codiceArticolo: string;

  listMatricoleDisponibili: ArticoliMatricola[];
  listMatricoleDisponibiliFiltrate: ArticoliMatricola[];
  attivaMatricola: boolean = false;
  listDettaglioRif: DettaglioMovimento;
  numMaxDaconsegnare: number = 0;
  numConsegnati: number = 0;
  idArticoloMatricolaDaAssegnare: number;

  msgErrorDettaglioMov: string;

  visibleLoadPanel: boolean = false;

  newArticoloMatricola: ArticoliMatricola;
  idArticoloRif: number;
  listPropsArtNewMatricola: any[];
  gestMatricole: boolean = false;

  dipendente: string;
  buttonDipendente: boolean = true;
  dipendenteInserito: boolean = false;
  descrizioneArticolo: string;
  sezioneArticolo: boolean = false;

  popupSceltaDipendente: boolean = false;
  popupSceltaArticolo: boolean = false;
  gestioneMatricola: boolean = false;
  matricolaArticolo: string;
  rigaSelezionata: DettaglioMovimento;
  popupSceltaMatricola: boolean = false;
  matricolaRigaSelezionata: string;
  intVerificaSottoscorta: number;

  ngOnInit(): void {
    this.gestMatricole = this.isModVisible('Matricole');

    this.nuovoMovimento = new MovimentoArticoloModel();
    this.nuovoMovimento.listDettaglio = [];
    this.dataConsegna = new Date();
    this.isBase =
      this.storageService.utenteCorrente.ruoloString == RUOLO_OPERATORE_BASE;
    this.loadLookUp();

    this.listDettaglioRif = new DettaglioMovimento();
    this.listDettaglioRif.listMatricoleConsegna = [];
  }

  loadLookUp() {
    //Lista dei dipendenti
    this.dipendentiService.listTemp().subscribe({
      next: (res) => {
        this.listDipendenti = res.filter(x => x.attivo);
      }
    });

    //List Articoli
    this.articoliService.listTemp().subscribe({
      next: (res) => {
        this.listArticoli = res.filter(x => x.attivo == true);
        this.listArticoliFiltro = res.filter(x => x.attivo == true);
      }
    });

    //List MatricoleArticoli
    this.matricoleService.list().subscribe({
      next: (res) => {
        this.listMatricole = res;
      },
      error: (err) => {
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio('Errore recupero lista matricole', 'error');
        }
      },
    });

    //List TipiArticoli
    this.tipiArticoliService.list().subscribe({
      next: (res) => {
        this.listTipiArticoli = res;
      },
      error: (err) => {
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio('Errore recupero lista tipi articoli', 'error');
        }
      },
    });

    //Lit KitArticoli
    this.kitArticoliService.list().subscribe({
      next: (res) => {
        this.listKitArticoli = res;
      },
      error: (err) => {
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio('Errore lista kit articoli', 'error');
        }
      },
    });

    //Valore verifica sottoscorta
    this.parametriService.get('verifica-sottoscorta').subscribe({
      next: (res) => {
        this.intVerificaSottoscorta = res.valNum;
      },
      error: (err) => {
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio(
            'Errore recupero valore controllo sottoscorta',
            'error',
          );
        }
      },
    });
  }

  isMax1600(): boolean {
    return window.matchMedia('(max-width: 1600px)').matches;
  }

  onTipoArticoloChanged(rowData: any, value: any) {
    rowData.idTipoArticolo = value;
    const idTipo = value;
    this.listArticoliFiltro = this.listArticoli.filter(
      (x) => x.idTipo == idTipo,
    );
    console.log(this.listArticoliFiltro);
  }

  getFilteredArticoli(options) {
    const ret = {
      store: this.listArticoliFiltro,
      filter: options.data
        ? ['idTipo', '=', options.data.idTipoArticolo]
        : null,
    };
    return ret;
  }

  onEditorPreparing(e: any) {
    if (
      e.parentType === 'dataRow' &&
      (e.dataField === 'idTipoArticolo' || e.dataField === 'idArticolo')
    ) {
      // editabile SOLO in insert
      e.editorOptions.disabled = !e.row?.isNewRow;
    }
  }

  onDipendenteSelected(e: any) {
    const idDipendente = e.value;
    this.codiceDipendente = this.listDipendenti.find(
      (x) => x.id == idDipendente,
    )?.codice;
  }

  onCodiceDipendenteChanged() {
    let dip = this.listDipendenti.find(
      (x) => x.codice == this.codiceDipendente,
    );
    if (dip != undefined) {
      this.idDipendente = dip.id;
      this.dipendente = dip.codice + '-' + dip.nominativo;
      this.sezioneArticolo = true;

      // this.barcodeArticoloTxtBox.instance.focus();
      this.codiceDipendente = '';
      this.dipendenteInserito = true;
      this.buttonDipendente = false;
    } else {
      notificaMessaggio(
        'Dipendente non attivo o codice dipendente errato',
        'warning',
      );
      this.codiceDipendente = '';
      return;
    }
  }

  getArticoloDisplay(dataRow: any): string {
    const articolo = this.listArticoliFiltro.find(
      (a) => a.id === dataRow.idArticolo,
    );

    if (!articolo) {
      return '';
    }

    let s =
      articolo.codice +
      (articolo.taglia ? ' - ' + articolo.taglia : '') +
      ' - ' +
      articolo.descrizione;

    if (dataRow.matricola) {
      s += ` (${dataRow.matricola})`;
    } else if (this.listMatricole?.some((x) => x.idArticolo === articolo.id)) {
      s += ' (matricola da scegliere)';
    }

    return s;
  }

  async onFocusedRowChanged(e) {
    if (!e || !e.row || !e.row.data) {
      return;
    }

    const rowData = e.row.data;
    this.listDettaglioRif = this.nuovoMovimento.listDettaglio.find(
      (x) =>
        x.idArticolo == rowData.idArticolo &&
        x.dataInserimento == rowData.dataInserimento,
    );
    if (!this.listDettaglioRif.listMatricoleConsegna) {
      this.listDettaglioRif.listMatricoleConsegna = [];
    }
    this.idArticoloRif = rowData.idArticolo;

    //controllo se deve usare la matricola
    if (this.listMatricole.find((x) => x.idArticolo == rowData.idArticolo)) {
      rowData.usaMatricola = true;
    }
    this.gestioneMatricola = rowData.usaMatricola;
    this.matricolaRigaSelezionata = rowData.matricola;

    if (rowData.usaMatricola) {
      this.attivaMatricola = true;
      this.matricolaRigaSelezionata = rowData.matricola;
      this.numMaxDaconsegnare = rowData.qta;
      this.listMatricoleDisponibili = this.listMatricole.filter(
        (x) => x.idArticolo == rowData.idArticolo,
      );
      await this.loadMatricoleDisponibili(rowData.idArticolo);
      this.numConsegnati =
        this.listDettaglioRif?.listMatricoleConsegna?.length ?? 0;
      this.barcodeMatricola.instance.focus();
    } else {
      this.attivaMatricola = false;
    }

    //Prop Tipologia articolo
    if (
      this.gestMatricole &&
      this.gestioneMatricola &&
      rowData.idTipoArticolo
    ) {
      const tipologia = this.listTipiArticoli.find(
        (t) => t.id == rowData.idTipoArticolo,
      );
      this.listPropsArtNewMatricola = JSON.parse(tipologia.propJSON);
    }
  }

  async loadMatricoleDisponibili(idArticolo: number) {
    try {
      const res = await firstValueFrom(
        this.matricoleService.listDisponibili(idArticolo),
      );
      this.listMatricoleDisponibiliFiltrate = res;
    } catch (err: any) {
      if (err?.error?.title) {
        notificaMessaggio(err.error.title, 'error');
      } else {
        notificaMessaggio('Errore recupero matricole disponibili', 'error');
      }
      throw err;
    }
  }

  rowUpdated(e) {
    const rowData = e.data;
    const articolo = this.listArticoli.find((x) => x.id == rowData.idArticolo);
    if (articolo!.gestioneKit) {
      const articoliComponenti = this.listKitArticoli.filter(
        (x) => x.idArticolo == articolo!.id,
      );
      articoliComponenti.forEach((articoloComp) => {
        const index = this.nuovoMovimento.listDettaglio.findIndex(
          (x) => x.idArticolo == articoloComp.idArticoloComponente,
        );
        this.nuovoMovimento.listDettaglio[index].qta =
          rowData.qta * articoloComp.quantita;
      });
    }
    if (this.attivaMatricola) {
      this.numMaxDaconsegnare = rowData.qta;
    }
    this.listDettaglioRif.listMatricoleConsegna = [];
    this.convalidaMatricole();
  }

  convalidaMatricole() {
    if (this.numMaxDaconsegnare == this.numConsegnati) {
      this.listDettaglioRif.matricoleConvalidate = true;
    } else {
      this.listDettaglioRif.matricoleConvalidate = false;
    }

    this.gridDettaglioMov.instance.refresh();

    //nuovoMovimento.listDettaglio
  }

  eliminaArticolo(e: any) {
    this.nuovoMovimento.listDettaglio.forEach((element, index) => {
      if (element.idArticolo == e.row.data.idArticolo && element.matricola == e.row.data.matricola) {
        const articolo = this.listArticoli.find(x => x.id == element.idArticolo);
        if(articolo!.gestioneKit){
          const qtaPadre = element.qta;
          const componenti = this.listKitArticoli.filter(x => x.idArticolo == articolo.id);
          componenti.forEach(comp => {
            const artComponente = this.nuovoMovimento.listDettaglio.find(x => x.idArticolo == comp.idArticoloComponente);
            artComponente!.qta -= qtaPadre * comp.quantita;
            artComponente!.componenteFiglio = false;
            if(artComponente!.qta<=0){
              const indexArtComp = this.nuovoMovimento.listDettaglio.findIndex(x => x.idArticolo == artComponente.idArticolo);
              this.nuovoMovimento.listDettaglio.splice(indexArtComp, 1);
            }
          });
        }
        this.nuovoMovimento.listDettaglio.splice(index, 1);
      }
    });
    if(this.nuovoMovimento.listDettaglio.length > 0){
    setTimeout(() => {
      const temp = this.nuovoMovimento.listDettaglio[0];
        this.gridDettaglioMov.instance.selectRows(
          [temp.dataInserimento],
          false,
        );
        this.gridDettaglioMov.instance.option(
          'focusedRowKey',
          temp.dataInserimento,
        );
      }, 50);
    }
  }

  onInitNewRow(e: any) {
    e.data.cambio = false;
    e.data.listDettaglio = [];
  }

  onRowInserting(e: any) {
    this.listArticoliFiltro = this.listArticoli;
    const newRow = e.data;

    // Controllo  se esiste già la stessa chiave
    const exists = this.nuovoMovimento.listDettaglio.some(
      (item) => item.idArticolo === newRow.idArticolo,
    );

    if (exists) {
      notificaMessaggio('Questo articolo è già presente ', 'error');
      // Blocco l'inserimento
      e.cancel = true;
      return;
    }
    const art = this.listArticoli.find((x) => x.id == newRow.idArticolo);

    if (art!.gestioneKit) {
      this.inserisciArticoliKit(art!.id, newRow.qta);
    }
  }

  async onBarcodeArticolo() {
    if (this.codiceArticolo.includes('_')) {
      //Siamo nel caso della matricola
      const codiceEMatricola: string[] = this.codiceArticolo.split('_');
      const codiceArticolo: string = codiceEMatricola[0];
      const matricola: string = codiceEMatricola[1];

      this.descrizioneArticolo =
        this.listArticoli.find((x) => x.codice == codiceArticolo)!.descrizione +
        ' (' +
        matricola +
        ')';

      //Controllo che non sia già stato inserito
      const articolo = this.listArticoli.find(
        (x) => x.codice == codiceArticolo,
      );
      const indexAlreadyInserted = this.nuovoMovimento.listDettaglio.findIndex(
        (x) => x.idArticolo == articolo!.id && x.matricola == matricola,
      );
      if (indexAlreadyInserted >= 0) {
        notificaMessaggio('Articolo già inserito', 'warning');
        return;
      }

      if (articolo == undefined) {
        notificaMessaggio(
          'Articolo non attivo o codice articolo errato',
          'warning',
        );
        this.codiceArticolo = '';
        return;
      }

      //Controllo che la matricola inserita non sia già usata
      var matricolaUsata = this.nuovoMovimento.listDettaglio.find(
        (x) =>
          x.idArticolo == articolo.id &&
          x.matricola != undefined &&
          x.matricola == matricola,
      );
      if (matricolaUsata != undefined) {
        this.matricolaArticolo = '';
        notificaMessaggio('Matricola inserita già usata', 'warning');
        return;
      }

      const temp = new DettaglioMovimento();
      temp.idArticolo = articolo.id;
      temp.idTipoArticolo = articolo.idTipo;
      temp.qta = 1;
      temp.cambio = false;
      temp.usaMatricola = true;
      temp.matricoleConvalidate = true;
      temp.listMatricoleConsegna = [];
      temp.dataInserimento = this.getDataInserimento();
      temp.matricola = matricola; //Solo per visualizzazione
      if (this.listMatricoleDisponibiliFiltrate == undefined) {
        await this.loadMatricoleDisponibili(articolo.id);
      }

      const articoloMatricola = this.listMatricoleDisponibiliFiltrate.find(
        (x) => x.matricola == matricola,
      );

      if (articoloMatricola == undefined) {
        notificaMessaggio(
          'Matricola errata o non disponibile o già assegnata ad un altro articolo',
          'warning',
        );
        this.codiceArticolo = '';
        return;
      }

      const newAssegnazione = new ArticoliMatricola();
      newAssegnazione.id = articoloMatricola.id;
      newAssegnazione.idArticolo = articoloMatricola.idArticolo;
      newAssegnazione.matricola = articoloMatricola.matricola;
      temp.listMatricoleConsegna.push(newAssegnazione);
      this.nuovoMovimento.listDettaglio.push(temp);
      this.codiceArticolo = '';
      this.rigaSelezionata = temp;
      setTimeout(() => {
        this.gridDettaglioMov.instance.selectRows(
          [temp.dataInserimento],
          false,
        );
        this.gridDettaglioMov.instance.option(
          'focusedRowKey',
          temp.dataInserimento,
        );
      }, 50);
    } else {
      //Articolo senza matricola
      //Controllo che non sia già stato inserito
      const articoloInserito = this.listArticoli.find(
        (x) => x.codice == this.codiceArticolo,
      );
      if (articoloInserito == undefined) {
        notificaMessaggio(
          'Articolo non attivo o codice articolo errato',
          'warning',
        );
        this.codiceArticolo = '';
        return;
      }
      this.descrizioneArticolo = articoloInserito.descrizione;

      //Verifico che non sia un articolo con una matricola associabile
      const usaMatricola = this.listMatricole.find(
        (x) => x.idArticolo == articoloInserito.id,
      );
      if (usaMatricola != undefined) {
        const temp = new DettaglioMovimento();
        temp.idArticolo = articoloInserito.id;
        temp.idTipoArticolo = articoloInserito.idTipo;
        temp.qta = 1;
        temp.cambio = false;
        temp.usaMatricola = true;
        temp.dataInserimento = this.getDataInserimento();
        this.nuovoMovimento.listDettaglio.push(temp);
        this.codiceArticolo = '';
        setTimeout(() => {
          this.gridDettaglioMov.instance.selectRows(
            [temp.dataInserimento],
            false,
          );

          this.gridDettaglioMov.instance.option(
            'focusedRowKey',
            temp.dataInserimento,
          );
        }, 50);
        return;
      }

      //Sono sicuro che sia un articolo senza matricola
      const indexAlreadyInserted = this.nuovoMovimento.listDettaglio.findIndex(
        (x) => x.idArticolo == articoloInserito.id,
      );
      if (indexAlreadyInserted >= 0) {
        const alreadyInsertedArticolo =
          this.nuovoMovimento.listDettaglio[indexAlreadyInserted];
        if (
          this.listArticoli.find(
            (x) => x.id == alreadyInsertedArticolo.idArticolo,
          )?.gestioneKit
        ) {
          //Prelevo gli articoli kit e aggiungo la quantità
          const articoloKit = this.listKitArticoli.filter(
            (x) => x.idArticolo == alreadyInsertedArticolo.idArticolo,
          );
          articoloKit.forEach((articolo) => {
            let indexArticolo = this.nuovoMovimento.listDettaglio.findIndex(
              (x) => x.idArticolo == articolo.idArticoloComponente,
            );
            this.nuovoMovimento.listDettaglio[indexArticolo].qta +=
              articolo.quantita;
          });
        }
        this.nuovoMovimento.listDettaglio[indexAlreadyInserted].qta += 1;
        this.codiceArticolo = '';
        return;
      }

      const temp = new DettaglioMovimento();
      temp.idArticolo = articoloInserito.id;
      temp.idTipoArticolo = articoloInserito.idTipo;
      temp.qta = 1;
      temp.cambio = false;
      temp.usaMatricola = false;
      temp.kit = articoloInserito.gestioneKit;
      temp.dataInserimento = this.getDataInserimento();
      this.nuovoMovimento.listDettaglio.push(temp);
      this.codiceArticolo = '';
      //Verifico se è un articolo Kit
      if (articoloInserito.gestioneKit) {
        this.inserisciArticoliKit(articoloInserito.id, 1);
      }
      this.rigaSelezionata = temp;

      setTimeout(() => {
        const items = this.gridDettaglioMov.instance.getDataSource().items();
        console.log(items);
        this.gridDettaglioMov.instance.selectRows(
          [temp.dataInserimento],
          false,
        );
        this.gridDettaglioMov.instance.option(
          'focusedRowKey',
          temp.dataInserimento,
        );
      }, 50);
    }
  }

  getDataInserimento(): Date {
    this.lastInsertTime += 1001;
    return new Date(this.lastInsertTime);
  }

  inserisciArticoliKit(idArticoloKit: number, quantita: number) {
    const idsArticoliComponente = this.listKitArticoli
      .filter((x) => x.idArticolo == idArticoloKit)
      .map((x) => x.idArticoloComponente);
    idsArticoliComponente.forEach((idArticoloComponente) => {
      const articoloComponente = this.listArticoli.find(
        (x) => x.id == idArticoloComponente,
      );
      const articoloKit = this.listKitArticoli.find(
        (x) => x.idArticoloComponente == idArticoloComponente,
      );
      const articoloComponenteAlreadyInserted =
        this.nuovoMovimento.listDettaglio.find(
          (x) => x.idArticolo == idArticoloComponente,
        );
      if (articoloComponenteAlreadyInserted) {
        if (
          !this.listMatricole.some(
            (x) => x.idArticolo == articoloComponenteAlreadyInserted.idArticolo,
          )
        ) {
          const index = this.nuovoMovimento.listDettaglio.findIndex(
            (x) => x.idArticolo == idArticoloComponente,
          );
          this.nuovoMovimento.listDettaglio[index].qta += articoloKit!.quantita;
          return; //Salto questo ciclo
        }
      }
      const temp = new DettaglioMovimento();
      temp.idArticolo = articoloComponente!.id;
      temp.idTipoArticolo = articoloComponente!.idTipo;
      temp.qta = quantita * articoloKit!.quantita;
      temp.cambio = false;
      temp.usaMatricola = false;
      temp.componenteFiglio = true;
      temp.dataInserimento = this.getDataInserimento();
      this.nuovoMovimento.listDettaglio.push(temp);
    });
  }

  onRowPrepared(e: any) {
    if (e.rowType === 'data' && e.data?.componenteFiglio && !e.data?.kit) {
      e.rowElement.style.backgroundColor = '#f0eeee';
    }
  }

  async effettuaConsegna(e) {
    const result = e.validationGroup.validate('form-nuova-consegna');
    if (!result.isValid) {
      return; // blocca il salvataggio
    }

    //Controllo quantità
    if (this.intVerificaSottoscorta == 1 && this.quantitaInsufficiente()) {
      const resultSottoScorta = await confirm(
        '<i>Non hai tutti gli articoli in magazzino. Procedere?</i>',
        'Qauntità superiore',
      );

      if (!resultSottoScorta) {
        return;
      }
    }
    if (this.intVerificaSottoscorta == 2 && this.quantitaInsufficiente()) {
      notificaMessaggio(
        'Non ci sono abbastanza articoli in magazzino',
        'error',
      );
      return;
    }

    // Controllo gestione matricole
    if (!this.validaListaArticoli(this.nuovoMovimento.listDettaglio)) {
      notificaMessaggio('Gestione matricole incompleta.', 'warning');
      return; // blocca il salvataggio
    }

    //Richiedo di procedere o no
    const resultConferma = await confirm(
      '<i>Procedere con la consegna?</i>',
      'Consegna',
    );
    if (!resultConferma) {
      return;
    }

    this.nuovoMovimento.data = moment(this.dataConsegna).utc(true).toDate();
    this.nuovoMovimento.idDipendente = this.idDipendente;

    //Controllo se ho inserito almento un articolo
    this.msgErrorDettaglioMov = '';
    if (this.nuovoMovimento.listDettaglio.length == 0) {
      this.msgErrorDettaglioMov = 'Assegnare un articolo';
      return;
    }

    if (this.nuovoMovimento.listDettaglio.length > 0) {
      console.log('valori:' + JSON.stringify(this.nuovoMovimento));

      //Data
      const data = new Date(this.nuovoMovimento.data);
      this.nuovoMovimento.data = moment(data).utc(true).toDate();
      this.nuovoMovimento.gestioneGiornaliera =
        TipoGestioneGiornaliera.consegnaGiornaliera;
      this.visibleLoadPanel = true;
      this.movimentoService.insertGiornaliera(this.nuovoMovimento).subscribe({
        next: (res) => {
          this.visibleLoadPanel = false;
          if (res.result) {
            if (res.errori != null && res.errori.length > 0) {
              this.mostraAlertResult(
                res.errori,
                'Movimento inserito con avvisi:',
              );
            } else {
              notificaMessaggio('Movimento inserito', 'success');
              this.ripulisciDati();
              this.navigatorService.goToDocMovimento(res.newMovimento.progr, true);
            }
          } else {
            if (res.errori != null && res.errori.length > 0) {
              this.mostraAlertResult(res.errori, 'Movimento non inserito');
            }
            notificaMessaggio('Errore inserimento movimento', 'warning');
          }
        },
        error: (err) => {
          this.visibleLoadPanel = false;
          if (err?.error?.title) {
            notificaMessaggio(err.error.title, 'error');
          } else {
            notificaMessaggio(
              "Qualcosa è andato storto con l'inserimento del movimento",
              'error',
            );
          }
        },
      });
    }

    console.log(this.nuovoMovimento);
  }

  quantitaInsufficiente() {
    const idsArticoliSelezionati = this.nuovoMovimento.listDettaglio.map(
      (x) => x.idArticolo,
    );
    const listArticoliDb = this.listArticoli.filter((x) =>
      idsArticoliSelezionati.includes(x.id),
    );

    return this.nuovoMovimento.listDettaglio.some((articoloScelto) => {
      if (articoloScelto.usaMatricola) {
        return false;
      }

      const articoloDb = listArticoliDb.find(
        (x) => x.id == articoloScelto.idArticolo,
      );

      return articoloScelto.qta > articoloDb.giacenza;
    });
  }

  assegnaMatricola() {
    if (this.idArticoloMatricolaDaAssegnare) {
      this.aggiungiMatricola(this.idArticoloMatricolaDaAssegnare);
    } else {
      notificaMessaggio('Seleziona una matricola', 'warning');
    }
  }

  aggiungiMatricola(id) {
    if (id) {
      const matSel = this.listMatricoleDisponibili.find((x) => x.id == id);
      if (matSel) {
        //Aggiungo matricola alla lista
        const newAssegnazione = new ArticoliMatricola();
        newAssegnazione.id = id;

        newAssegnazione.idArticolo = matSel.idArticolo;
        newAssegnazione.matricola = matSel.matricola;

        this.listDettaglioRif.listMatricoleConsegna.push(newAssegnazione);
        this.numConsegnati =
          this.listDettaglioRif.listMatricoleConsegna?.length; //Calcolo num matricole inserite
        this.idArticoloMatricolaDaAssegnare = null;
        this.aggiornaListMatricoleDisponibili(); //Aggiorno lookup delle matricole da assegnare
        this.convalidaMatricole();
      }
    } else {
      notificaMessaggio('matricola non assegnata', 'warning');
    }
  }

  eliminaMatricolaArticolo(e) {
    this.listDettaglioRif.listMatricoleConsegna.forEach((element, index) => {
      if (element.id == e.row.data.id) {
        this.listDettaglioRif.listMatricoleConsegna.splice(index, 1); //Elimino dalla lista
        this.numConsegnati = this.listDettaglioRif.listMatricoleConsegna.length; //Agiorno il contatore
        this.aggiornaListMatricoleDisponibili(); //Aggiorno lookup delle matricole da assegnare
        this.convalidaMatricole();
      }
    });
  }

  aggiornaListMatricoleDisponibili() {
    if (this.listMatricoleDisponibili) {
      this.listMatricoleDisponibiliFiltrate =
        this.listMatricoleDisponibili.filter(
          (m) =>
            !this.listDettaglioRif?.listMatricoleConsegna?.some(
              (a) => a.id === m.id,
            ),
        );
    }
  }

  validaListaArticoli(lista: DettaglioMovimento[]): boolean {
    return lista.every((item) => {
      //Controllo che tutt gli elementi dell'array soddisifino la condizione
      if (item.usaMatricola) {
        return item.matricoleConvalidate === true;
      }
      return true; // se non usa matricola è automaticamente valido
    });
  }

  mostraAlertResult(errori: string[], title: string) {
    let strErroriHtml = '<ul>';
    errori.forEach((element) => {
      strErroriHtml += '<li>' + element + '</li>';
    });
    strErroriHtml += '</ul>';
    alert(strErroriHtml, title);
  }

  ripulisciDati() {
    this.nuovoMovimento = new MovimentoArticoloModel();
    this.nuovoMovimento.listDettaglio = [];
    this.listDettaglioRif = new DettaglioMovimento();
    this.listDettaglioRif.listMatricoleConsegna = [];
    this.codiceArticolo = '';
    this.attivaMatricola = false;
    this.descrizioneArticolo = '';
    this.gestioneMatricola = false;
    this.matricolaRigaSelezionata = undefined;
  }

  onBarcodeDipendenteTxtBoxInitialized(e) {
    e.component.focus();
  }
  onBarcodeArticoloTxtBoxInitialized(e) {
    e.component.focus();
  }

  onDipendenteCerca() {
    this.popupSceltaDipendente = true;
  }

  onArticoloCerca() {
    this.popupSceltaArticolo = true;
  }

  esci() {
    this.navigatorService.goToDashboardGiornaliera();
  }

  onIdDipendenteEventEmitter(e: any) {
    if (e == null) {
      this.popupSceltaDipendente = false;
      return;
    }
    let dip = this.listDipendenti.find((x) => x.id == e);
    if (dip != undefined) {
      this.idDipendente = dip.id;
      this.dipendente = dip.codice + '-' + dip.nominativo;
      this.sezioneArticolo = true;

      this.codiceDipendente = '';
      this.dipendenteInserito = true;
      this.buttonDipendente = false;
      this.popupSceltaDipendente = false;
    } else {
      notificaMessaggio(
        'Dipendente non attivo o codice dipendente errato',
        'warning',
      );
      this.codiceDipendente = '';
      this.popupSceltaDipendente = false;
      return;
    }
  }

  onArticoloEventEmitter(e) {
    if (e == null) {
      this.popupSceltaArticolo = false;
      return;
    }
    this.codiceArticolo = e;
    
      //Controllo se esiste l'articolo
      const articoloInserito = this.listArticoli.find(
        (x) => x.codice == this.codiceArticolo,
      );
      if (articoloInserito == undefined) {
        notificaMessaggio(
          'Articolo non attivo o codice articolo errato',
          'warning',
        );
        this.codiceArticolo = '';
        this.popupSceltaArticolo = false;
        return;
      }
      this.descrizioneArticolo = articoloInserito.descrizione;
      const indexAlreadyInserted = this.nuovoMovimento.listDettaglio.findIndex(
        (x) => x.idArticolo == articoloInserito.id && !x.usaMatricola,
      );
      if (indexAlreadyInserted >= 0) {
        const alreadyInsertedArticolo =
          this.nuovoMovimento.listDettaglio[indexAlreadyInserted];
        if (
          this.listArticoli.find(
            (x) => x.id == alreadyInsertedArticolo.idArticolo,
          )?.gestioneKit
        ) {
          //Prelevo gli articoli kit e aggiungo la quantità
          const articoloKit = this.listKitArticoli.filter(
            (x) => x.idArticolo == alreadyInsertedArticolo.idArticolo,
          );
          articoloKit.forEach((articolo) => {
            let indexArticolo = this.nuovoMovimento.listDettaglio.findIndex(
              (x) => x.idArticolo == articolo.idArticoloComponente,
            );
            this.nuovoMovimento.listDettaglio[indexArticolo].qta +=
              articolo.quantita;
          });
        }
        this.nuovoMovimento.listDettaglio[indexAlreadyInserted].qta += 1;
        this.codiceArticolo = '';
        this.popupSceltaArticolo = false;
        return;
      }

      const temp = new DettaglioMovimento();
      temp.idArticolo = articoloInserito.id;
      temp.idTipoArticolo = articoloInserito.idTipo;
      temp.qta = 1;
      temp.cambio = false;
      temp.usaMatricola = this.listMatricole.find(x => x.idArticolo == articoloInserito.id) != undefined;
      temp.matricola = undefined;
      temp.kit = articoloInserito.gestioneKit;
      temp.dataInserimento = this.getDataInserimento();
      this.nuovoMovimento.listDettaglio.push(temp);
      this.codiceArticolo = '';
      this.popupSceltaArticolo = false;
      //Verifico se è un articolo Kit
      if (articoloInserito.gestioneKit) {
        this.inserisciArticoliKit(articoloInserito.id, 1);
      }
      this.rigaSelezionata = temp;
      setTimeout(() => {
        this.gridDettaglioMov.instance.selectRows(
          [temp.dataInserimento],
          false,
        );
        this.gridDettaglioMov.instance.option(
          'focusedRowKey',
          temp.dataInserimento,
        );
      }, 50);
      if(temp.usaMatricola){
        this.barcodeMatricola.instance.focus();
      }
  }

  getDescrizione() {
    const tipo = this.listTipiArticoli.find(
      (x) => x.id == this.rigaSelezionata.idTipoArticolo,
    );
    return (
      tipo.descrizione + ' ' + this.getArticoloDisplay(this.rigaSelezionata)
    );
  }

  onMatricolaCerca() {
    var idArticolo = this.rigaSelezionata.idArticolo;
      var matricoleUsate = this.nuovoMovimento.listDettaglio
        .filter(
          (x) =>
            x.usaMatricola &&
            x.matricola != undefined &&
            x.idArticolo == idArticolo,
        )
        .map((x) => x.matricola);
      this.listMatricoleDisponibiliFiltrate = this.listMatricoleDisponibiliFiltrate.filter(
        (x) => !matricoleUsate.includes(x.matricola),
      );
    this.popupSceltaMatricola = true;
  }

  onIdMatricolaEventEmitter(e) {
    if (e == null) {
      return;
    }
    const matricola = this.listMatricoleDisponibiliFiltrate.find(
      (x) => x.id == e,
    );
    if (matricola == undefined) {
      notificaMessaggio('Matricola errata o non disponibile', 'warning');
      this.popupSceltaMatricola = false;
      return;
    }
    var matricolaGiaUsata = this.nuovoMovimento.listDettaglio.find(
      (x) => x.matricola == matricola.matricola,
    );
    if (matricolaGiaUsata != undefined) {
      notificaMessaggio('Matricola già utilizzata', 'warning');
      this.popupSceltaMatricola = false;
      return;
    }
    let dett = this.nuovoMovimento.listDettaglio.find(
      (x) =>
        x.idArticolo == this.rigaSelezionata.idArticolo &&
        x.matricola == undefined,
    );
    dett.matricola = matricola.matricola;
    dett.matricoleConvalidate = true;
    const newAssegnazione = new ArticoliMatricola();
    newAssegnazione.id = matricola.id;
    newAssegnazione.idArticolo = matricola.idArticolo;
    newAssegnazione.matricola = matricola.matricola;
    dett.listMatricoleConsegna.push(newAssegnazione);
    this.popupSceltaMatricola = false;
    this.gestioneMatricola = false;
    this.matricolaRigaSelezionata = matricola.matricola;
    this.barcodeArticoloTxtBox.instance.focus();
  }

  onMatricolaArticolo() {
    const matricola = this.listMatricoleDisponibiliFiltrate.find(
      (x) => x.matricola == this.matricolaArticolo,
    );
    if (matricola == undefined) {
      notificaMessaggio('Matricola errata o non disponibile', 'warning');
      this.matricolaArticolo = '';
      return;
    }
    if (
      this.nuovoMovimento.listDettaglio.find(
        (x) =>
          x.matricola != undefined &&
          x.matricola == this.matricolaArticolo &&
          x.idArticolo == this.rigaSelezionata.idArticolo,
      ) != undefined
    ) {
      notificaMessaggio('Matricola già utilizzata', 'warning');
      this.matricolaArticolo = '';
      return;
    }
    let dett = this.nuovoMovimento.listDettaglio.find(
      (x) =>
        x.idArticolo == this.rigaSelezionata.idArticolo &&
        x.matricola == undefined,
    );
    dett.matricola = matricola.matricola;
    dett.matricoleConvalidate = true;
    const newAssegnazione = new ArticoliMatricola();
    newAssegnazione.id = matricola.id;
    newAssegnazione.idArticolo = matricola.idArticolo;
    newAssegnazione.matricola = matricola.matricola;
    dett.listMatricoleConsegna.push(newAssegnazione);
    this.gestioneMatricola = false;
    this.matricolaRigaSelezionata = matricola.matricola;
    this.matricolaArticolo = '';
    this.barcodeArticoloTxtBox.instance.focus();
  }

  onSelectionChanged(e: any) {
    this.rigaSelezionata = e.selectedRowsData[0];

    if (!this.rigaSelezionata) {
      return;
    }
  }

  onQtaChanged(e, rowData: DettaglioMovimento) {
    const articoloKit = this.listKitArticoli.filter(
      (x) => x.idArticolo == rowData.idArticolo,
    );
    if (articoloKit.length != 0) {
      const idsComponenti = articoloKit.map((x) => x.idArticoloComponente);
      let listComponenti = this.nuovoMovimento.listDettaglio.filter((x) =>
        idsComponenti.includes(x.idArticolo),
      );
      listComponenti.forEach((comp) => {
        const moltiplicatore = e.value - e.previousValue;
        comp.qta +=
          moltiplicatore *
          articoloKit.find((x) => x.idArticoloComponente == comp.idArticolo)
            .quantita;
      });
    }
    rowData.qta = e.value;
  }

  needVerificaGiacenza() {
    return this.intVerificaSottoscorta > 0;
  }

  qtaInsufficiente(idArticolo?: number) {
    if (idArticolo == undefined) {
      idArticolo = this.rigaSelezionata.idArticolo;
    }
    const articoloDb = this.listArticoli.find((x) => x.id == idArticolo);
    if (articoloDb == undefined) {
      notificaMessaggio('Articolo inserito insesistente', 'error');
      return;
    }
    const riga = this.nuovoMovimento.listDettaglio.find(
      (x) => x.idArticolo == idArticolo,
    );
    if(riga == undefined){
      return;
    }
    if (riga.usaMatricola) {
      //Se ho la matricola esiste solo un elemento e lo gestisco con la scelta delle matricole
      return false;
    }
    return riga.qta > articoloDb.giacenza;
  }
}
